/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbToastrService, NbSidebarService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { NbIconLibraries } from '@nebular/theme';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NbAclService, NbAccessChecker } from '@nebular/security';
import { RouterConst } from './common/router.const';
import * as moment from 'moment';
import { NbPasswordAuthStrategy, NbAuthJWTToken } from '@nebular/auth';
import api from './services/api';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(private analytics: AnalyticsService,
    private toastrService: NbToastrService,
    private translate: TranslateService,
    private sidebarService: NbSidebarService,
    public accessChecker: NbAccessChecker,
    private iconLibraries: NbIconLibraries,
    private router: Router,
    private auth: NbPasswordAuthStrategy,
    private aclService: NbAclService) {
    moment.locale('vi');
    translate.setDefaultLang('vi');
    iconLibraries.registerFontPack('ms-Fabric', { iconClassPrefix: 'ms-Icon-', packClass: 'ms-Icon' });
    // iconLibraries.setDefaultPack('ms-Fabric');
  }

  ngOnInit(): void {
    //(<any>window).pdfWorkerSrc = '/assets/pdf.worker.js';
    this.analytics.trackPageViews();

    //Thay doi khi pulish
    //var url = window.location.pathname != '/' ? window.location.origin + window.location.pathname + 'api' : window.location.origin + '/api'
    //var url = 'http://10.14.138.8:3000/emr/api'

    //Thay doi khi chay debug
    var url = api.url;

    this.auth.setOptions({
      name: 'AuthEMR',
      token: {
        class: NbAuthJWTToken,
        key: 'NewToken'
      },
      //baseEndpoint: window.location.origin + window.location.pathname + '/api',
      baseEndpoint: url,
      login: {
        // ...
        endpoint: api.Authorize.Login,
        method: 'post',
        redirect: {
          success: '/pages/trang-chu',
          failure: null, // stay on the same page
        },
      },
      logout: {
        // ...
        endpoint: api.Authorize.Logout,
        method: 'post',
        redirect: {
          success: '/auth/login',
          failure: null, // stay on the same page
        },
      },
    })
    this.aclService.setAccessControl({
      Guest: {
        access: []
      },
      User: {
        view: ['tableHistory'],
        access: ['/pages/trang-chu',
          '/pages/tables/tao-yeu-cau',
          '/pages/lich-su-yeu-cau',
          '/pages/thong-tin-phieu',
          '/pages/quan-ly-tai-khoan/ho-so-benh-an',
          '/pages/tables/nghien-cuu-khoa-hoc',
          '/pages/tables/tham-dinh-benh-an',
          '/pages/tables/lap-tom-tat',
          '/pages/tom-tat-benh-an',
          '/pages/tom-tat-ho-so',
          '/pages/history-medical',
          `/${RouterConst.PAGES}/${RouterConst.TRANG_CHU}/${RouterConst.TRANG_CHU_NGUOI_KHAI_THAC}`,
          `/${RouterConst.PAGES}/${RouterConst.C_CDA_VIEWER}`],
      },
      IT: {
        access: ['/pages/trang-chu',
          '/pages/quan-ly-tai-khoan/danh-sach-nguoi-dung',
          '/pages/quan-ly-tai-khoan/danh-sach-nhom-nguoi-dung',
          '/pages/quan-ly-tai-khoan/danh-sach-nguoi-dung-trong-nhom',
          '/pages/quan-ly-tai-khoan/phan-quyen-chuc-nang',
          '/pages/quan-ly-tai-khoan/thong-tin-nguoi-dung',
          `/${RouterConst.PAGES}/${RouterConst.QUAN_LY_TAI_KHOAN}/${RouterConst.USER_GROUP_DETAIL}`,
          `/${RouterConst.PAGES}/${RouterConst.QUAN_LY_TAI_KHOAN}/${RouterConst.USER_GROUP_ADD}`,
          `/${RouterConst.PAGES}/${RouterConst.TRANG_CHU}/${RouterConst.TRANG_CHU_QUAN_TRI}`,
          `/${RouterConst.PAGES}/${RouterConst.TRUY_VET}/${RouterConst.LICH_SU_KHAI_THAC_HSBA}`,
          `/${RouterConst.PAGES}/${RouterConst.TRUY_VET}/${RouterConst.LICH_SU_TRUY_CAP_HE_THONG}`
        ],
        view: ['QuanLyHoSo', 'ThongKeTheoNgay', 'TongLuotTruyeCap', 'NhatKyCongViec']
      },
      Approver: {
        access: ['/pages/trang-chu',
          '/pages/quan-ly-yeu-cau',
          '/pages/tables/tra-cuu-benh-an',
          '/pages/duyet-phieu',
          '/pages/tables/history-medical',
          `/pages/${RouterConst.TRA_CUU_HO_SO}`,
          `/${RouterConst.PAGES}/${RouterConst.TRANG_CHU}/${RouterConst.TRANG_CHU_QUAN_TRI}`],
        view: ['YeuCauChoDuyet', 'ThongKeTheoNgay', 'NhatKyCongViec']
      },
    })

    //this.accessChecker.isGranted('access', '/pages/trang-chu').subscribe(val => {
    //  if (!val) {        // check guest roles
    //    this.router.navigateByUrl(`auth/logout`);
    //  }
    //})

    this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        this.sidebarService.expand('menu-sidebar')
        // setTimeout(() => this.sidebarService.toggle(true, 'menu-sidebar'))
      }
      //if (event instanceof NavigationEnd) {

      //}

      //if (event instanceof NavigationError) {
      //  // Hide loading indicator

      //  // Present error to user
      //  console.log(event.error);
      //}
    });
  }
}
